<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              placeholder="输入关键字快速搜索..."
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- 头部按钮 -->
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="formLoad('add')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="150px">
        <el-row :gutter="20">
          <el-form-item :label="$l('label_demand_status') || '状态'">
            <el-col :span="24">
              <el-checkbox-group v-model="form.fabricStockOutStatusArr">
                <el-checkbox label="N" name="type">{{
                  $l('label_newly_added') || '新增申请'
                }}</el-checkbox>
                <el-checkbox label="Y" name="type">{{
                  $l('label_out_of_stock') || '已出库'
                }}</el-checkbox>
                <el-checkbox label="D" name="type">{{
                  $l('label_deleted') || '已删除'
                }}</el-checkbox>

                <el-checkbox label="P" name="type">
                  {{ $l('INDEX.Pending') || '审批中' }}
                </el-checkbox>
                <el-checkbox label="B" name="type">
                  {{ $l('INDEX.Rejected') || '驳回' }}
                </el-checkbox>
                <el-checkbox label="A" name="type">{{
                  $l('label_audit') || '已审核'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('label_odd_numbers') || '出库单号'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.fabricStockOutNo"
                :placeholder="$l('label_odd_numbers') || '出库单号'"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('label_applicant') || '申请人'"
            prop="fabricAgentCode"
          >
            <el-col :span="24">
              <dict-select
                v-model="form.fabricAgentCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('INDEX.create_date') || '创建日期'">
            <el-col :span="11">
              <el-date-picker
                v-model="form.createDateBegin"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.createDateEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改日期'"
          >
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyDateBegin"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyDateEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      form: {
        searchKey: '',
        fabricStockOutNo: '',
        fabricAgentCode: '',
        createDateBegin: '',
        createDateEnd: '',
        modifyDateBegin: '',
        modifyDateEnd: '',
        fabricStockOutStatusArr: ['Y', 'N', 'A', 'P', 'B'],
      },
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {
    this.query()
  },
  methods: {
    formLoad(type) {
      this.$emit('formLoad', type)
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    closeDialog() {
      this.visible = false
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        fabricStockOutStatusArr: ['Y', 'N', 'A', 'P', 'B'],
      }
      this.clickQuery()
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
